import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { env } from './env';

if ( env.NODE_ENV === 'production' ) {
  Sentry.init( {
    dsn:
      'https://9735043fbeb0aabb59fd17cd2a52b3c5@o419716.ingest.us.sentry.io/4509135689613312',
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
    environment: env.REACT_APP_SENTRY_ENVIRONMENT,
  } );
}
